<!-- MODAL equivalenciasModal -->
<div mdbModal #equivalenciasModal="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'ADD'">Agregar Equivalencia</h4>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="CloseEquivalenciasModal()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body producto-equivalencia__modal-add-edit">
          <div class="row">
            <div class="col">
              <h6 class="modal-title w-100 text-left" id="myModalLabel">Datos de Equivalencia</h6>
            </div>
            <div class="col">
              <div class="switch info-switch">
                <label>
                  Inactivo
                  <input type="checkbox" color="info" checked="true" formControlName="activado" />
                  <span class="lever"></span>
                  Activo
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <ng-container *ngIf="equivalencia_producto?.fueUsadaEnTransaccion">
                <h5 class="producto-equivalencia__modal-add-edit__info-warning">Equivalencia ya fue usada en una
                  transacción</h5>
              </ng-container>
            </div>
          </div>
          <div class="row" [ngClass]="{ disabledContent: mode === 'EDIT' }">
            <div class="col" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" class="form-control" placeholder="" required
                  formControlName="cliente_proveedor_rut" formatRut disabled />
                <label for="rutproveedor">RUT Proveedor</label>
                <div
                  *ngIf="formHeader.get('cliente_proveedor_rut').invalid && (formHeader.get('cliente_proveedor_rut').dirty || formHeader.get('cliente_proveedor_rut').touched)">
                  <mdb-error *ngIf="formHeader.get('cliente_proveedor_rut').hasError('required')"> Ingrese Proveedor
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents">
                {{ proveedorSeleccionado.nombre }}
              </h6>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5>Datos Producto (Proveedor)</h5>
            </div>
          </div>
          <div class="row" [ngClass]="{ disabledContent: equivalencia_producto?.fueUsadaEnTransaccion }">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="codigo" class="form-control" required
                  formControlName="producto_proveedor" />
                <label for="codigo">Código</label>
                <div
                  *ngIf="formHeader.get('producto_proveedor').invalid && (formHeader.get('producto_proveedor').dirty || formHeader.get('producto_proveedor').touched)">
                  <mdb-error *ngIf="formHeader.get('producto_proveedor').hasError('required')"> Ingrese código
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="detalle" class="form-control" required
                  formControlName="detalle_producto" disabled />
                <div
                  *ngIf="formHeader.get('detalle_producto').invalid && (formHeader.get('detalle_producto').dirty || formHeader.get('detalle_producto').touched)">
                  <mdb-error *ngIf="formHeader.get('detalle_producto').hasError('required')"> Ingrese detalle
                  </mdb-error>
                </div>
                <label for="detalle">Detalle Producto</label>
              </div>
            </div>
          </div>
          <div class="row" [ngClass]="{ disabledContent: equivalencia_producto?.fueUsadaEnTransaccion }">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="formato_codigo" class="form-control" required
                  formControlName="formato_codigo" disabled />
                <div
                  *ngIf="formHeader.get('formato_codigo').invalid && (formHeader.get('formato_codigo').dirty || formHeader.get('formato_codigo').touched)">
                  <mdb-error *ngIf="formHeader.get('formato_codigo').hasError('required')"> Ingrese formato </mdb-error>
                </div>
                <label for="detalle">Formato Codigo</label>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="factor" class="form-control" required #cant monto
                  formControlName="factor_equivalencia" />
                <div
                  *ngIf="formHeader.get('factor_equivalencia').invalid && (formHeader.get('factor_equivalencia').dirty || formHeader.get('factor_equivalencia').touched)">
                  <mdb-error *ngIf="formHeader.get('factor_equivalencia').hasError('required')"> Ingrese Factor
                  </mdb-error>
                  <mdb-error *ngIf="formHeader.get('factor_equivalencia').hasError('min')">El factor debe ser mayor a 0
                  </mdb-error>
                </div>
                <label for="detalle">Factor de Equivalencia</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5>Datos Producto (ERP)</h5>
            </div>
          </div>
          <div class="row" [ngClass]="{ disabledContent: equivalencia_producto?.fueUsadaEnTransaccion }">
            <div class="col producto-equivalencia__modal-add-edit__sku_input">
              <div class="md-form">
                <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                  formControlName="producto_sku" />
                <label for="codProduct">Producto Maestro ERP</label>
                <div
                  *ngIf="formHeader.get('producto_sku').invalid && (formHeader.get('producto_sku').dirty || formHeader.get('producto_sku').touched)">
                  <mdb-error *ngIf="formHeader.get('producto_sku').hasError('required')"> Ingrese código de producto
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col d-flex">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionarProducto()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" style="display: contents" *ngIf="productoSeleccionado">
                {{ productoSeleccionado.descripcion }}
              </h6>
            </div>
          </div>
          <div class="row" [ngClass]="{ disabledContent: equivalencia_producto?.fueUsadaEnTransaccion }">
            <div class="col" style="max-width: 250px">
              <div class="md-form">
                <mdb-select [options]="optionsFormato" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar formato"
                  formControlName="formato_codigo_top"></mdb-select>
                <label>Formato</label>
                <div
                  *ngIf="formHeader.get('formato_codigo_top').invalid && (formHeader.get('formato_codigo_top').dirty || formHeader.get('formato_codigo_top').touched)">
                  <mdb-error *ngIf="formHeader.get('formato_codigo_top').hasError('required')"> Ingrese formato
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body producto-equivalencia__modal-add-edit">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="observacion" class="form-control" placeholder="Observaciones"
                  #observacion formControlName="observacion" />
                <label for="observacion">Observaciones</label>
                <ng-container *ngIf="equivalencia_producto?.fueUsadaEnTransaccion">
                  <div
                    *ngIf="formHeader.get('observacion').invalid && (formHeader.get('observacion').dirty || formHeader.get('observacion').touched)">
                    <mdb-error *ngIf="formHeader.get('observacion').hasError('required')"> Ingrese observación
                    </mdb-error>
                    <mdb-error *ngIf="formHeader.get('observacion').hasError('maxlength')"> Máximo 200 caracteres
                    </mdb-error>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <ng-container *ngIf="mode === 'ADD'">
            <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
              (click)="CloseEquivalenciasModal()" mdbWavesEffect>Cerrar</button>
            <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
              (click)="create()">Guardar</button>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="true"
  (onNotFound)="onProductoNoEncontrado($event)"> </app-modal-seleccionar-producto>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>

<!-- MODAL confirmación producto inactivo -->
<div mdbModal #modalConfirmacionProductoInactivo="mdb-modal" class="modal fade" id="modalConfirmacionProductoInactivo"
  tabindex="-1" role="dialog" aria-labelledby="modalProductoInactivoLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #a1a1a1; color: white;">
        <h4 class="modal-title w-100 text-center" id="modalProductoInactivoLabel">
          <mdb-icon fas icon="exclamation-triangle" class="mr-2"></mdb-icon>
          Producto Desactivado
        </h4>
      </div>
      <div class="modal-body py-4" *ngIf="productoInactivoTemporal">
        <div class="mb-3">
          <strong>Código:</strong> {{ productoInactivoTemporal.sku }}
        </div>
        <div class="mb-3">
          <strong>Descripción:</strong> {{ productoInactivoTemporal.descripcion }}
        </div>
        <p class="mb-4">
          Se encuentra desactivado en el sistema.
        </p>
        <p class="mb-4">
          ¿Desea utilizarlo de todas formas?
        </p>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" mdbWavesEffect
          (click)="rechazarUsoProductoInactivo()">
          Cancelar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
          (click)="confirmarUsoProductoInactivo()">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
